import React from 'react';
import ReactDOM from 'react-dom/client';
import Curtain from './components/curtain';
import './assets/css/index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Curtain />
  </React.StrictMode>
);

